import { render, staticRenderFns } from "./BufferManagement.vue?vue&type=template&id=4626a2f3"
import script from "./BufferManagement.vue?vue&type=script&lang=js"
export * from "./BufferManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports